import { a as get, l as post } from "./utils2.mjs";
import { N8N_IO_BASE_URL } from "@n8n/constants";

//#region src/api/prompts.ts
async function getPromptsData(instanceId, userId) {
	return await get(N8N_IO_BASE_URL, "/prompts", {}, {
		"n8n-instance-id": instanceId,
		"n8n-user-id": userId
	});
}
async function submitContactInfo(instanceId, userId, email) {
	return await post(N8N_IO_BASE_URL, "/prompt", { email }, {
		"n8n-instance-id": instanceId,
		"n8n-user-id": userId
	});
}

//#endregion
export { submitContactInfo as n, getPromptsData as t };
//# sourceMappingURL=prompts.mjs.map